export const CAL_EVENT_TEMPLATE_TEXT_MAX_LENGTH = 2048;
//# sourceMappingURL=cal-event-template-text-max-length.js.map